/**
 * Recovery from a failed dynamic-import preload (cc3-pplb.2).
 *
 * A deploy replaces the hashed asset files and the frontend rsync deletes the
 * previous build (`synchronize dist/ ... delete: true`), while tabs that are
 * already open keep naming the old chunks. The next lazy route then fails with
 * "Unable to preload CSS for /assets/<chunk>-<hash>.css" — 10 GlitchTip issues,
 * ~1700 events, all carrying a stale release hash.
 *
 * Reloading picks up the new index.html and fixes it. But if the asset is gone
 * for any OTHER reason the reload lands on the same broken page and reloads
 * again — an endless loop on a terminal an inmate cannot escape. Hence the
 * cooldown, and hence every unclear case refusing to reload.
 */
export const PRELOAD_RELOAD_KEY = 'cc3:preload-reload-at'
export const PRELOAD_RELOAD_COOLDOWN_MS = 10000

/**
 * Decide whether to reload, and record the decision.
 *
 * @param storage a Storage-like object (sessionStorage in the browser)
 * @param now epoch milliseconds
 * @returns true when the caller should reload
 */
export function markPreloadReload(storage, now) {
  if (!storage) return false

  let previous
  try {
    previous = storage.getItem(PRELOAD_RELOAD_KEY)
  } catch (err) {
    // Storage blocked: without memory there is no way to break a loop.
    return false
  }

  if (previous !== null && previous !== undefined) {
    const last = Number(previous)
    if (!Number.isFinite(last)) return false
    if (now < last) return false
    if (now - last <= PRELOAD_RELOAD_COOLDOWN_MS) return false
  }

  try {
    storage.setItem(PRELOAD_RELOAD_KEY, String(now))
  } catch (err) {
    // An unrecorded reload is the first step of the loop.
    return false
  }
  return true
}
